import uz from "./uz.json";
import ru from "./ru.json";
import en from "./en.json";
import kr from './kr.json'

export const resource = {
  uz: {
    translation: uz,
  },
  ru: {
    translation: ru,
  },
  en: {
    translation: en,
  },
  kr: {
    translation: kr
  }
};
